import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { getFrontendConfig } from "../api";

interface Props {
    children?: ReactNode;
}

interface FeatureFlags {
    promocionesIndexEnabled: boolean;
}

// Default: mostrar (mismo comportamiento actual) hasta que llegue la config del backend.
const defaultFlags: FeatureFlags = {
    promocionesIndexEnabled: true
};

const FeatureFlagsContext = createContext<FeatureFlags>(defaultFlags);

export const useFeatureFlags = () => useContext(FeatureFlagsContext);

export const FeatureFlagsProvider = ({ children }: Props) => {
    const [flags, setFlags] = useState<FeatureFlags>(defaultFlags);

    useEffect(() => {
        getFrontendConfig()
            .then(cfg => setFlags({ promocionesIndexEnabled: cfg.promocionesIndexEnabled }))
            .catch(() => setFlags(defaultFlags));
    }, []);

    return <FeatureFlagsContext.Provider value={flags}>{children}</FeatureFlagsContext.Provider>;
};
